export const ROUTER_LMS_CLASSROOM = {
	admin: {
		exercises: '/lms/admin/exercises'
	}
}
